import { ITop } from './interfaces/top.reduce.interface';

export const getGameTopList = ({ top }: ITop) => top.listTop;
